import { render, staticRenderFns } from "./upload-bill-multi-com.vue?vue&type=template&id=447633cb&"
import script from "./upload-bill-multi-com.vue?vue&type=script&lang=js&"
export * from "./upload-bill-multi-com.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "upload-bill-multi-com.vue"
export default component.exports